import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GetAccessModule } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (previlage) => async (dispatch, getState) => {
    
    dispatch({ type: GetAccessModule, accessmodules: fromJS({}), time: new Date().getTime() });

    const Authorization = UserToken;
    const url = ApiUrl2 + 'config-accessmodule-list';
    var paramBody = {
        "query":{
            "privilege-id":previlage,
        }       
    };
    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };  

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result');
    }

    dispatch({ type: GetAccessModule, accessmodules: fromJS(data), time: new Date().getTime() });
};